import React from 'react';
import styles from './Typography.module.css';

type TypographyProps = {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  children: React.ReactNode;
  className?: string;
};

export const Typography: React.FC<TypographyProps> = ({ variant = 'p', children, className }) => {
  const Tag = variant;
  return <Tag className={`${[styles[variant], className].filter(Boolean).join(' ')} ${styles.text}`}>{children}</Tag>;
}; 